import { gql } from '@apollo/client/core';

export const getLocations = gql`
  query GetLocations {
    getLocations {
      id
      state
      county
      township
      updater
      createdAt
      updatedAt
      deletedAt
    }
  }
`;
